import { BracketWinnerEnum } from "./BracketWinnerEnum";

export default class BracketGamePredictionFixturesModel {
  public matchId: string = "";
  public participantOne: string = "";
  public participantTwo: string = "";
  public winner: BracketWinnerEnum | null;
  public correct: boolean | null = null;
}
